import { Box, Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { alert } from "lib/@dialogs/alert"
import { ScheduleBackButton } from "slot-definitions"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"

export function EditBackButton() {
    const { saveStatus } = useBoundContext()
    const hasUnsyncedChanges = saveStatus === "queued" || saveStatus === "error"

    ScheduleBackButton.usePlug(
        replaceAllWith(
            <Box>
                <Button
                    size="small"
                    color="primary"
                    className="back-button"
                    onClick={handleBack}
                    startIcon={<Iconify icon="ic:round-keyboard-backspace" />}
                    variant="contained"
                    data-cy="back-button"
                >
                    Back
                </Button>
            </Box>
        ),
        [hasUnsyncedChanges]
    )

    return null

    async function handleBack() {
        if (!hasUnsyncedChanges) {
            window.history.back()
            return
        }
        await alert(
            "You have unsynced changes. Your changes are saved on this device and will sync when the connection is restored.",
            "Unsaved changes"
        )
    }
}
